import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { CSP_POLICY } from './assets/csp/csp';
import { environment } from './environments/environment';

function injectCSP(policy: string) {
	const cspMeta = document.createElement('meta');
	cspMeta.httpEquiv = 'Content-Security-Policy';
	cspMeta.content = policy.trim().replace(/\s+/g, ' ');
	document.head.appendChild(cspMeta);
}

// Unregister any existing service worker in test/development mode to prevent cached config issues
if (!environment.production && 'serviceWorker' in navigator) {
	navigator.serviceWorker.getRegistrations().then(registrations => {
		registrations.forEach(registration => {
			registration.unregister().then(() => {
				console.log('Service worker unregistered for test/development environment');
			});
		});
	});
}

injectCSP(CSP_POLICY);

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(`Bootstrap Failed ${err}`));
